var map = {
	"./ai-screenshot-de.jpg": 64735,
	"./ai-screenshot-en.jpg": 31771,
	"./ai-screenshot-fr.jpg": 51982,
	"./dog.png": 46934,
	"./fast-colors.svg": 36531,
	"./forward-colors.svg": 49472,
	"./frontiers-in-vet-science.png": 47863,
	"./improve-colors.svg": 25238,
	"./laptop-phone.png": 93157,
	"./logo-drliabeuf.png": 9534,
	"./logo-generic.png": 84939,
	"./logo-languedocia.png": 9690,
	"./logo-picoxia-ia.svg": 56836,
	"./performance.svg": 61902,
	"./report.png": 75264,
	"./vet-radio-and-ultrasound.png": 44725,
	"./vhs.png": 25953,
	"./zen-colors.svg": 20240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43899;